import { action } from 'typesafe-actions';
import * as CONST from './consts';
import { OrganisationModel } from './model';

export const getOrganisationRequest = () => action(CONST.GET_ORGANISATION_REQUEST);
export const getOrganisationSuccess = (organisation: OrganisationModel) =>
  action(CONST.GET_ORGANISATION_SUCCESS, { organisation });
export const getOrganisationError = (error: unknown) => action(CONST.GET_ORGANISATION_ERROR, { error });
